/**
 * Кастомная иконка «Камера» — outline camera
 *
 * stroke="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function CameraOutlineIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3686 3.09183C16.4878 3.54759 16.8302 5.13485 17.2879 5.64504C17.7455 6.15522 18.4004 6.32869 18.7628 6.32869C20.6887 6.32869 22.25 7.92614 22.25 9.89547V16.4656C22.25 19.1072 20.1557 21.25 17.5738 21.25H6.42622C3.84322 21.25 1.75 19.1072 1.75 16.4656V9.89547C1.75 7.92614 3.31132 6.32869 5.23722 6.32869C5.59846 6.32869 6.25335 6.15522 6.71211 5.64504C7.16976 5.13485 7.51105 3.54759 8.63024 3.09183C9.75054 2.63606 14.2495 2.63606 15.3686 3.09183Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0894 9.26941H18.1001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5224 13.3826C15.5224 11.3918 13.9456 9.77844 11.9997 9.77844C10.0539 9.77844 8.47705 11.3918 8.47705 13.3826C8.47705 15.3735 10.0539 16.9868 11.9997 16.9868C13.9456 16.9868 15.5224 15.3735 15.5224 13.3826Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
